import { Menu, MenuItem } from '@mui/material'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Box } from '@mui/system'
import { useState } from 'react'
import CookiesStorageService from '../../../../services/CookiesStorageService'
import { userAuthLogout, userAuthResetAlertHandler } from '../../../../redux/features/userAuth/userAuthThunk'
import { getFirstAndSecondCharacterOnly } from '../../../../utils/helpers'
import IconWithName from './iconWithName'
import { ReactComponent as LogoutIcon } from '../../../../images/LogoutIcon.svg'
import { ReactComponent as HomeIcon } from '../../../../images/HomeNavIcon.svg'
import { ReactComponent as PasswordIcon } from '../../../../images/PasswordIcon.svg'
import TranslationButton from '../../../Buttons/TranslationButton'
import UseTranslation from '../../../../hooks/UseTranslation'

import SwitchModulesBtn from './SwitchModulesBtn'
import ChangePasswordModal from '../../../Modals/ChangePasswordModal'
import { selectAuthUser } from '../../../../redux/features/userAuth/userAuthSlice'
import LoaderWithErrorHandler from '../../../PageHelpers/LoaderWithErrorHandler'
import HoverTooltip from '../../../PageHelpers/HoverTooltip'

const Index = ({ menuState, changeMenuState }) => {
  const userAuth = useSelector(selectAuthUser)
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = UseTranslation()
  const [changePasswordModalState, setChangePasswordModalState] = useState(false)

  const logoutHandler = async () => {
    const logoutDone = await dispatch(userAuthLogout())

    if (logoutDone) {
      history.push('/')
    }
  }
  const userName = CookiesStorageService.getUserName() ?? t?.User
  const isSamlUser = CookiesStorageService.getIsSamlUser()

  return (
    <Box>
      <Menu
        sx={styles.root}
        id='menu-appbar'
        anchorEl={menuState}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={Boolean(menuState)}
        onClose={changeMenuState}>
        <MenuItem onClick={changeMenuState}>
          <Box sx={[styles.menuItemBtn, styles.userNameBtn]}>
            <Box sx={styles.userShortName}>
              {getFirstAndSecondCharacterOnly(userName)}
            </Box>
            <Box sx={styles.userName}>
              <HoverTooltip title={userName}>
                {`${userName?.slice(0, 20)} ${userName?.length > 20 ? '...' : ''}`}
              </HoverTooltip>
            </Box>
          </Box>
        </MenuItem>

        {CookiesStorageService.getUserModules()?.length > 1 && (<MenuItem>
          <Box sx={styles.menuItemBtn}>
            <IconWithName name={t?.['Welcome Screen']} icon={<HomeIcon />} onClick={() => history.push('/switch-modules')} />
          </Box>
        </MenuItem>)}

        {CookiesStorageService.getUserModules()?.length > 1 && (<MenuItem>
          <Box sx={styles.menuItemBtn}>
            <SwitchModulesBtn />
          </Box>
        </MenuItem>)}

        <MenuItem sx={styles.menuItemBtn} onClick={changeMenuState}>
          <TranslationButton />
        </MenuItem>
{!isSamlUser && (
        <MenuItem onClick={() => {
          setChangePasswordModalState(true)
          changeMenuState(false)
        }}>
          <Box sx={styles.menuItemBtn} onClick={() => { }}>
            <IconWithName name={t?.['Change Password']} icon={<PasswordIcon />} />
          </Box>
        </MenuItem>
)}
        <MenuItem onClick={changeMenuState}>
          <Box sx={styles.menuItemBtn} onClick={logoutHandler}>
            <IconWithName name={t?.logout} icon={<LogoutIcon />} />
          </Box>
        </MenuItem>
      </Menu>

      <ChangePasswordModal
        formModalState={changePasswordModalState}
        setFormModalState={setChangePasswordModalState}
      />

     <LoaderWithErrorHandler store={userAuth} resetAlertHandler={userAuthResetAlertHandler}/>
    </Box>

  )
}

const styles = {
  root: {
    mt: { xs: '38px', sm: '45px' },
    '& .MuiPaper-root': {
      borderRadius: '12px',
      paddingTop: '5px',
      paddingBottom: '15px',
    },
    '& ul': {
      minWidth: '200px',
      padding: 0,
      borderRadius: '30px',
    },
    '& li': {
      borderTop: '1px solid #ededed',
    },
    '& .MuiBox-root': {
      margin: '0',
    },
  },
  menuItemBtn: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: { xs: '10px 5px', sm: '10px' },
    fontSize: { xs: '14px', sm: '18px' },
    textTransform: 'capitalize',
    transition: 'all 0.5s',
    marginBottom: '10px',
    marginLeft: '15px',
    '& svg': {
      marginRight: 0,
    },
  },
  userNameBtn: {
    paddingBottom: '5px',
  },
  userShortName: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: { xs: '30px', sm: '40px' },
    height: { xs: '30px', sm: '40px' },
    backgroundColor: 'primary.main',
    color: 'white',
    borderRadius: '50%',
    fontSize: { xs: '14px', sm: '18px' },
    fontFamily: 'Avenir-bold !important',
    textTransform: 'uppercase',
    marginRight: '20px',
  },
  userName: {
    marginLeft: '15px !important',
    fontSize: { xs: '14px', sm: '18px' },
  },
}

export default Index
